module.exports = __webpack_public_path__ + "i18n/ja.8cd2ec41279c8a87f2e51e4eb1c84f87.json";


//////////////////
// WEBPACK FOOTER
// ./node_modules/file-loader?name=i18n/[name].[hash].[ext]!./i18n/ja.json
// module id = 1310
// module chunks = 59